import { render, staticRenderFns } from "./SalesDataReadOnly.vue?vue&type=template&id=4c7962c0"
import script from "./SalesDataReadOnly.vue?vue&type=script&lang=js"
export * from "./SalesDataReadOnly.vue?vue&type=script&lang=js"
import style0 from "./SalesDataReadOnly.vue?vue&type=style&index=0&id=4c7962c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports